import "./polyfills.js";

// import 'src/utils/resize';
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
// import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux";
import store from "../src/store";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

localStorage.setItem("locale", "zh-TW");
dayjs.locale("zh-cn");
const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<Provider store={store}>
		<App />
	</Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
